import styled from "styled-components";
import { borderRadius, panelSpacing } from "../../../../common/styles";
import colors from "../../../../config/colors";

export const ProgramContentContainer = styled.div`
  background-color: #fafafa;
  border-radius: ${borderRadius}px;
  width: ${(props) =>
    props.hamburgerOpen === true ? " calc(100vw - 270px)" : "100vw"};
  margin-left: auto;
  transition: 0.5s;
  @media (max-width: 1600px) {
    width: ${(props) =>
      props.hamburgerOpen === true ? " calc(100vw - 270px)" : "100vw"};
  }
  @media (max-width: 991px) {
    width: 100%;
  }
`;
export const SelectContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const JoinOrApplyButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const LabelProgramDashboard = styled.p`
  justify-content: center;
  align-items: center;
  font-weight: 600;
  margin-top: 30px;
`;

export const LabelButton = styled.button`
  justify-content: center;
  align-items: center;
  font-weight: 600;
`;

export const JoinPorgramContainer = styled.div`
  width: 80vh;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 20px;
  flex-direction: row-reverse;
  order-radius: 10px 10px 0px 0px;
  background: #fff;
  margin: 16px 12px;
  @media (max-width: 991px) {
    flex-direction: row;
  }
`;

export const HamburgerIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  @media (max-width: 991px) {
    margin-top: ${(props) => (props.isProgram ? "" : "12px")};
    margin-right: ${(props) => (props.isProgram ? "25px" : "0")};
    order: ${(props) => (props.isProgram ? "2" : "")};
    ${(props) =>
      props.setStyleMenu &&
      `
      margin-top: 5px;
    `}
  }

  @media (max-width: 480px) {
    margin-top: 5px;
  }
`;

export const NoProgramContainer = styled.div`
  padding: 20px;
  position: absolute;
  top: 55px;
  right: 11px;
  @media (max-width: 991px) {
    top: ${(props) => (props.meetingMode ? "62px" : "42px")};
    right: ${(props) => (props.meetingMode ? "50px" : "40px")};
  }
  @media (max-width: 480px) {
    top: ${(props) => (props.meetingMode ? "52px" : "42px")};
    right: ${(props) => (props.meetingMode ? "22px" : "40px")};
  }
`;

export const HamburgerIconContainerSpan = styled.span`
  width: 30px;
  height: 4px;
  background-color: #44449b;
  display: none;
  @media (max-width: 991px) {
    display: block;
  }
`;
export const ProgramTabContainer = styled.div`
  overflow-x: auto;
  margin-left: 20px;

  @media (max-width: 992px) {
    margin-left: 0px;
    width: calc(100% - 70px);
  }
`;
